import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EditNameDialogComponent} from './edit-name-dialog.component';
import {ChappsCommonAngularLibraryModule} from "@npm.chapps.com/chapps.common.angular.library";
import {TranslateModule} from "@ngx-translate/core";


@NgModule({
  declarations: [
    EditNameDialogComponent
  ],
  imports: [
    CommonModule,
    ChappsCommonAngularLibraryModule,
    TranslateModule
  ]
})
export class EditNameDialogModule {
}
